import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "help-h4",
  "use": "help-h4-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"help-h4\">\n<path d=\"M1.00269 1.9502V14.0511\" stroke=\"#333333\" stroke-linejoin=\"bevel\" />\n<path d=\"M7.80957 1.9502V14.0511\" stroke=\"#333333\" stroke-linejoin=\"bevel\" />\n<path d=\"M1.38086 8.00098H7.43132\" stroke=\"#333333\" stroke-linejoin=\"bevel\" />\n<path d=\"M13.8511 14.0514V6.48828L10.4565 11.403V12.1681H14.9944\" stroke=\"#333333\" stroke-linejoin=\"bevel\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol